module.exports = __webpack_public_path__ + "img/16_57.151db186.png";